import { ModuleConfig, ModuleFields } from "~/Utils/drilldownData";

export const getAirportLocationDrillDownData: { [key in ModuleConfig]: ModuleFields[] } = {
  airportLocations: [
    {
      fieldName: "Title (EN)",
      fieldValue: "title",
      className: "col-span-6",
      type: "text",
      name: "title",
      formType: "input",
      label: "Title (EN)",
      placeholder: "Enter Title (EN)",
      validation: { required: "Title (EN) is required" },
    },
    // {
    //   fieldName: "Title (MS)",
    //   fieldValue: "field_airport_name_ms",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_airport_name_ms",
    //   formType: "input",
    //   label: "Title (MS)",
    //   placeholder: "Enter Title (MS)",
    //   // validation: { required: "Title is required" },
    // },
    // {
    //   fieldName: "Title (ZH)",
    //   fieldValue: "field_airport_name_zh",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_airport_name_zh",
    //   formType: "input",
    //   label: "Title (ZH)",
    //   placeholder: "Enter Title (ZH)",
    //   // validation: { required: "Title is required" },
    // },
    {
      fieldName: "Parent Airport",
      fieldValue: "parent_term_name",
      className: "col-span-6",
      type: "select",
      name: "parent_term_name",
      formType: "select",
      label: "Parent Airport",
      placeholder: "Select Parent Airport",
      options: [],
      validation: { required: "Parent Airport is required" },
    },
    {
      fieldName: "Child Airport",
      fieldValue: "name",
      className: "col-span-6",
      type: "select",
      name: "name",
      formType: "select",
      label: "Child Airport",
      placeholder: "Select Child Airport",
      options: [],
      // validation: { required: "Child Airport is required" },
    },
    // {
    //   fieldName: "Key",
    //   fieldValue: "key",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "key",
    //   formType: "input",
    //   label: "Key",
    //   placeholder: "Enter Key",
    //   validation: { required: "Key is required" },
    // },
    {
      fieldName: "Short Form",
      fieldValue: "short_form",
      className: "col-span-6",
      type: "text",
      name: "short_form",
      formType: "input",
      label: "Short Form",
      placeholder: "Enter Short Form",
      validation: { required: "Short Form is required" },
    },
    {
      fieldName: "Address (EN)",
      fieldValue: "address_english",
      className: "col-span-6",
      type: "text",
      name: "address_english",
      formType: "input",
      label: "Address (EN)",
      placeholder: "Enter Address (EN)",
      validation: { required: "Address (EN) is required" },
    },
    {
      fieldName: "Address (MS)",
      fieldValue: "address_malay",
      className: "col-span-6",
      type: "text",
      name: "address_malay",
      formType: "input",
      label: "Address (MS)",
      placeholder: "Enter Address (MS)",
      // validation: { required: "Address is required" },
    },
    {
      fieldName: "Address (ZH)",
      fieldValue: "address_mandarin",
      className: "col-span-6",
      type: "text",
      name: "address_mandarin",
      formType: "input",
      label: "Address (ZH)",
      placeholder: "Enter Address (ZH)",
      // validation: { required: "Address is required" },
    },
    // {
    //   fieldName: "Value",
    //   fieldValue: "value",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "value",
    //   formType: "input",
    //   label: "Value",
    //   placeholder: "Enter Value",
    //   validation: { required: "Value is required" },
    // },
    {
      fieldName: "Telephone",
      fieldValue: "tel",
      className: "col-span-6",
      type: "text",
      name: "tel",
      formType: "number",
      label: "Telephone",
      placeholder: "Enter Telephone",
      validation: { required: "Telephone is required" },
    },
    {
      fieldName: "Fax",
      fieldValue: "fax",
      className: "col-span-6",
      type: "text",
      name: "fax",
      formType: "number",
      label: "Fax",
      placeholder: "Enter Fax",
      validation: { required: "Fax is required" },
    },
    {
      fieldName: "Longitude",
      fieldValue: "longitude",
      className: "col-span-6",
      type: "text",
      name: "longitude",
      formType: "input",
      label: "Longitude",
      placeholder: "Enter Longitude",
      validation: { required: "Longitude is required" },
    },
    {
      fieldName: "Latitude",
      fieldValue: "latitude",
      className: "col-span-6",
      type: "text",
      name: "latitude",
      formType: "input",
      label: "Latitude",
      placeholder: "Enter Latitude",
      validation: { required: "Latitude is required" },
    },
    {
      fieldName: "Location Direction",
      fieldValue: "location_direction",
      className: "col-span-6",
      type: "text",
      name: "location_direction",
      formType: "input",
      label: "Location Direction",
      placeholder: "Enter Location Direction",
      validation: { required: "Location Direction is required" },
    },
    // {
    //   fieldName: "Airport Location Redirect",
    //   fieldValue: "airport_location_redirect",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "airport_location_redirect",
    //   formType: "input",
    //   label: "Airport Location Redirect",
    //   placeholder: "Enter Airport Location Redirect",
    //   validation: { required: "Airport Location Redirect is required" },
    // },

    {
      fieldName: "Published",
      fieldValue: "published",
      className: "col-span-12",
      type: "checkbox",
      name: "published",
      formType: "checkbox",
      label: "Published",
      placeholder: "Enter Published",
      // validation: { required: "Publish is required" },
    },
  ],
  parentAirport: [
    {
      fieldName: "Name (EN)",
      fieldValue: "name",
      className: "col-span-6",
      type: "text",
      name: "name",
      formType: "input",
      label: "Name (EN)",
      placeholder: "Enter Name (EN)",
      validation: { required: "Name (EN) is required" },
    },
    {
      fieldName: "Name (MS)",
      fieldValue: "title_malay",
      className: "col-span-6",
      type: "text",
      name: "title_malay",
      formType: "input",
      label: "Name (MS)",
      placeholder: "Enter Name (MS)",
      // validation: { required: "Name (MS) is required" },
    },
    {
      fieldName: "Name (ZH)",
      fieldValue: "title_mandarin",
      className: "col-span-6",
      type: "text",
      name: "title_mandarin",
      formType: "input",
      label: "Name (ZH)",
      placeholder: "Enter Name (ZH)",
      // validation: { required: "Name (ZH) is required" },
    },
    {
      fieldName: "Published",
      fieldValue: "published",
      className: "col-span-12",
      type: "checkbox",
      name: "published",
      formType: "checkbox",
      label: "Published",
      placeholder: "Enter Published",
      // validation: { required: "Publish is required" },
    },
  ],
  childAirport: [
    {
      fieldName: "Name (EN)",
      fieldValue: "name",
      className: "col-span-6",
      type: "text",
      name: "name",
      formType: "input",
      label: "Name (EN)",
      placeholder: "Enter Name (EN)",
      validation: { required: "Name (EN) is required" },
    },
    {
      fieldName: "Name (MS)",
      fieldValue: "title_malay",
      className: "col-span-6",
      type: "text",
      name: "title_malay",
      formType: "input",
      label: "Name (MS)",
      placeholder: "Enter Name (MS)",
      // validation: { required: "Name (MS) is required" },
    },
    {
      fieldName: "Name (ZH)",
      fieldValue: "title_mandarin",
      className: "col-span-6",
      type: "text",
      name: "title_mandarin",
      formType: "input",
      label: "Name (ZH)",
      placeholder: "Enter Name (ZH)",
      // validation: { required: "Name (ZH) is required" },
    },
    {
      fieldName: "Parent Airport",
      fieldValue: "parent_term_name",
      className: "col-span-6",
      type: "select",
      name: "parent_term_name",
      formType: "select",
      label: "Parent Airport",
      placeholder: "Select Parent Airport",
      options: [],
      validation: { required: "Parent Airport is required" },
    },
    {
      fieldName: "Published",
      fieldValue: "published",
      className: "col-span-12",
      type: "checkbox",
      name: "published",
      formType: "checkbox",
      label: "Published",
      placeholder: "Enter Published",
      // validation: { required: "Publish is required" },
    },
  ],
  mapPageHeading: [
    {
      fieldName: "Page Banner Image",
      fieldValue: "field_page_banner_image",
      className: "col-span-6",
      type: "image",
      name: "field_page_banner_image",
      formType: "file",
      usedFileType: "image/*",
      label: "Page Banner Image",
      placeholder: "Upload Page Banner Image",
      validation: { required: "At least one Image is required" },
    },
    {
      fieldName: "Page Title (EN)",
      fieldValue: "field_page_title_en",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_en",
      formType: "input",
      label: "Page Title (EN)",
      placeholder: "Enter Page Title (English)",
      validation: { required: "At least one title is required" },
    },
    {
      fieldName: "Page Title (MS)",
      fieldValue: "field_page_title_ms",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_ms",
      formType: "input",
      label: "Page Title (MS)",
      placeholder: "Enter Page Title (Malay)",
    },
    {
      fieldName: "Page Title (ZH)",
      fieldValue: "field_page_title_zh",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_zh",
      formType: "input",
      label: "Page Title (ZH)",
      placeholder: "Enter Page Title (Mandarin)",
    },
    {
      fieldName: "Page Description (EN)",
      fieldValue: "field_page_description_en",
      className: "col-span-6",
      type: "text",
      name: "field_page_description_en",
      formType: "richText",
      label: "Page Description (EN)",
      placeholder: "Enter Page Description (English)",
      // validation: { required: "At least one Description is required" },
    },
    {
      fieldName: "Page Description (MS)",
      fieldValue: "field_page_description_ms",
      className: "col-span-6",
      type: "text",
      name: "field_page_description_ms",
      formType: "richText",
      label: "Page Description (MS)",
      placeholder: "Enter Page Description (Malay)",
    },
    {
      fieldName: "Page Description (ZH)",
      fieldValue: "field_page_description_zh",
      className: "col-span-6",
      type: "text",
      name: "field_page_description_zh",
      formType: "richText",
      label: "Page Description (ZH)",
      placeholder: "Enter Page Description (Mandarin)",
    },
  ],
};
